import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";

const WhatsappFloatingIcon = () => {

    const [setting, setSetting] = useState({});

    async function siteSettting() {
        try {
            let url = `https://backend.redbullludo.com/settings/data`;

            const result = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('access_token') || ''}`
                }
            });
            setSetting(result?.data);
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        siteSettting();
    }, [])


    return (
        <a
            href={setting?.telegramLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
                position: "fixed",
                bottom: "60px",
                right: "20px",
                zIndex: 1000,

                boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textDecoration: "none",
            }}
        >
            <img
                src="/Telegram_logo.svg.png"
                alt="WhatsApp"
                style={{ width: "50px", height: "50px" }}
            />
        </a>
    );
};

export default WhatsappFloatingIcon;